import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const getCompaniesApi = Configuration.Company_Endpoints.list
const getCompaniesLookupsApi = Configuration.Company_Endpoints.lookup
const getCompaniesModulesApi = Configuration.Company_Endpoints.modules
const addCompanyApi = Configuration.Company_Endpoints.add
const lastTenantApi = Configuration.Company_Endpoints.lastTenant
const getFabsTenantsApi = Configuration.Company_Endpoints.fabsTenants

export const retrieveCompanies = createAsyncThunk(
  'companies/getCompanies',
  async (_, { getState }) => {
    const { companies } = getState()
    const response = await RestClient.getRequest(
      `${getCompaniesApi}?page_size=${companies.pageSize}`,
    )
    return response.data
  },
)

export const retrieveCompaniesList = createAsyncThunk('companies/lookups', async () => {
  const res = await RestClient.getRequest(`${getCompaniesLookupsApi}`)

  return res?.data
})

export const companyPagination = createAsyncThunk(
  'companies/companyPagination',
  async ({ queries }, { getState }) => {
    const { companies } = getState()
    const response = await RestClient.getRequest(
      `${getCompaniesApi}?page_size=${companies.pageSize}&page_number=${queries.pageNumber}&search=${companies.activeSearch}&data_status=${companies.activeSummary}&sort_by=${companies.activeSort.key}`,
    )
    return { response: response.data, pageNumber: queries.pageNumber }
  },
)

export const filterCompanies = createAsyncThunk(
  'companies/companyByStatus',
  async ({ queries }, { getState }) => {
    const { companies } = getState()
    const response = await RestClient.getRequest(
      `${getCompaniesApi}?page_size=${companies.pageSize}&search=${companies.activeSearch}&data_status=${queries}&sort_by=${companies.activeSort.key}`,
    )
    return { response: response.data, summary: queries }
  },
)

export const sortCompanies = createAsyncThunk(
  'companies/sortCompany',
  async ({ queries }, { getState }) => {
    const { companies } = getState()
    const response = await RestClient.getRequest(
      `${getCompaniesApi}?page_size=${companies.pageSize}&search=${companies.activeSearch}&data_status=${companies.activeSummary}&sort_by=${queries.key}`,
    )
    return { response: response.data, sort: queries }
  },
)

export const searchCompanies = createAsyncThunk(
  'companies/searchCompanies',
  async ({ queries }, { getState }) => {
    const { companies } = getState()
    const response = await RestClient.getRequest(
      `${getCompaniesApi}?page_size=${companies.pageSize}&search=${queries || ''}&data_status=${
        companies.activeSummary
      }&sort_by=${companies.activeSort.key}`,
    )
    return { response: response.data, search: queries }
  },
)

export const addCompany = createAsyncThunk('companies/addCompany', async ({ body }, { rejectWithValue }) => {
  const response = await axios.post(addCompanyApi, body)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const editCompany = createAsyncThunk('companies/editCompany', async ({ body, id }, { rejectWithValue }) => {
  const response = await axios.put(`${addCompanyApi}/${id}`, body)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const companyChangeStatus = createAsyncThunk(
  'companies/changeStatus',
  async ({ queries }, { rejectWithValue }) => {
    const module_ids = []
    queries.data.modules?.forEach((singleModule) => {
      module_ids.push(singleModule.id)
    })

    let body
    if (queries.title === 'Active') {
      body = { active: true, suspended: false, name: queries.data.name, module_ids }
    } else if (queries.title === 'Disabled') {
      body = { active: false, suspended: false, name: queries.data.name, module_ids }
    } else if (queries.title === 'Suspended') {
      body = { active: false, suspended: true, name: queries.data.name, module_ids }
    }
    const response = await axios.put(`${addCompanyApi}/${queries.data.id}`, body)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const lastTenant = createAsyncThunk('companies/lastTenant', async () => {
  const response = await RestClient.getRequest(lastTenantApi)
  return response.data
})

export const retrieveCompaniesModules = createAsyncThunk('companies/modules', async () => {
  const res = await RestClient.getRequest(`${getCompaniesModulesApi}`)

  return res?.data
})

export const retrieveCompaniesFabsTenants = createAsyncThunk('companies/fabsTenants', async () => {
  const res = await RestClient.getRequest(`${getFabsTenantsApi}`)
  return res?.data
})
